<template>
  <div>
    <el-dialog v-bind='$attrs' v-on='$listeners' @opened='onOpened' @close='onClose' :title='dialogTitle' width='75%'>
      <div>
        <div class="default-table">
          <el-table :data="dataList" highlight-current-row row-class-name="row-style" @row-click="handleDoubleClick">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="invoice_title" label="抬头" header-align="center" align="left"></el-table-column>
            <el-table-column prop="tax_id" label="税号"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="province" label="省"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="city" label="市"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="area" label="区"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="address" label="地址"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="telephone" label="电话"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="bank_name" label="开户行"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="bank_amount" label="银行账号"  header-align="center" align="center"></el-table-column>
<!--            <el-table-column prop="invoice_type" label="发票类型"  header-align="center" align="center"></el-table-column>-->
            <el-table-column prop="invoice_content" label="发票内容"  header-align="center" align="center"></el-table-column>
            <el-table-column prop="invoice_email" label="接收发票邮箱"  header-align="center" align="center"></el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px">
         <span style="color: red">*</span> PS：点击选取开票信息
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {getSaleCustomHistoryTitleList} from "@/api/customers";

export default {
  name: "CompanyTitle",
  props: {
    customerId: {
      type: [Number, String]

    }
  },
  computed: {
    dialogTitle() {
      return `客户的历史开票信息`
    }
  },
  data() {
    return {
      searchCondition: {customer_id: null},
      dataList: [],
      pages: {current_page: null, page_size: null},
      info: {},
      tipList: [
        '该客户历史开票信息记录',
      ]
    }
  },
  methods: {
    onOpened() {
      this.searchCondition.customer_id = this.customerId
      // this.searchCondition.month = this.$utils.getCurrentMonth()
      this.getCompanyTitleList()
    },
    onClose() {

    },
    close() {
      this.$emit('update:visible', false)
    },
    async getCompanyTitleList() {
      this.dataList = []
      if (this.searchCondition.customer_id) {
        let {list, pages} = await getSaleCustomHistoryTitleList(this.searchCondition).then((res) => {

          return res.model;
        })
        this.$nextTick(() => {
          this.dataList = list
          this.pages = pages
        })
      } else {
        this.$notify.warning("请先选择客户!!!");
        this.close()
      }


    },
    // eslint-disable-next-line
    handleDoubleClick(	row, column, event){
      // console.log(row)
      // console.log(column)
      // console.log(event)
      this.$emit('handleSelect',row)
    }
  }
}
</script>

<style>

.row-style{
  cursor: pointer;
}
</style>